import React from 'react'
import Loader from 'react-loader-spinner'

class CustomLoader extends React.Component {
  render() {
    return(
      <div className="reactloaderspinner">
        <Loader
          type="Oval"
          color="#3a7294"
          height="100"
          width="100"
        />
      </div>
    );
  }
}

export default CustomLoader



// WEBPACK FOOTER //
// ./src/js/components/Loader.js